var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { getStyleValue } from '../elementInfo';
var cached;
/**
 * 获取滚动条大小
 * @param fresh
 */
export function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }
  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = '0px';
    outerStyle.left = '0px';
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;
    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }
    try {
      document.body.removeChild(outer);
    } catch (e) {}
    cached = widthContained - widthScroll;
  }
  return cached;
}
export function getScrollOffset(hasSize, fresh) {
  var info = {
    left: document.body.scrollLeft + document.documentElement.scrollLeft,
    top: document.body.scrollTop + document.documentElement.scrollTop
  };
  if (hasSize) {
    var width = getScrollBarSize(fresh);
    return __assign(__assign({}, info), {
      width: width
    });
  }
  return info;
}
export function hasHorizontalScrollbar(prevScrollSize) {
  var paddingBottom = getStyleValue(window.document.body, 'paddingBottom');
  var scrollSize = prevScrollSize || getScrollBarSize();
  return paddingBottom !== 0 && paddingBottom === scrollSize || document.body.scrollWidth > (window.innerWidth || document.documentElement.clientWidth);
}
export function hasVerticalScrollbar(prevScrollSize) {
  var paddingRight = getStyleValue(window.document.body, 'paddingRight');
  var scrollSize = prevScrollSize || getScrollBarSize();
  return paddingRight !== 0 && paddingRight === scrollSize || document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight);
}
export function hasScrollbar(prevScrollSize) {
  var scrollSize = prevScrollSize || getScrollBarSize();
  return hasVerticalScrollbar(scrollSize) || hasHorizontalScrollbar(scrollSize);
}
export function scrollTo(x, y, forbidBehavior) {
  if (x === void 0) {
    x = 0;
  }
  if (y === void 0) {
    y = 0;
  }
  if (!window || !window.scrollTo) {
    return;
  }
  if (forbidBehavior) {
    window.scrollTo(x, y);
    return;
  }
  try {
    window.scrollTo({
      left: x,
      top: y,
      behavior: 'smooth'
    });
  } catch (e) {
    window.scrollTo(x, y);
  }
}